import { ColorPicker, Input, Preview, Picker, Palette, Color } from './styles'

ColorPicker.Input = Input
ColorPicker.Preview = Preview
ColorPicker.Picker = Picker
ColorPicker.Palette = Palette
ColorPicker.Color = Color

export default ColorPicker
